import type { ZudokuConfig } from "zudoku";
import Welcome from "./Welcome";
import Tabs from "./pages/changelog/Tabs";
import Unauthorized from "./pages/Unauthorized";
import AdvancedContent from "./pages/AdvancedContent";
import AdvancedGuardScript from "./pages/AdvancedGuardScript";
import ComingSoon from "./pages/changelog/upcoming/soon/ComingSoon";

const config: ZudokuConfig = {
  // theme: {
  //   light: {
  //     background: "#ffffff",
  //     foreground: "#020817",
  //     card: "#ffffff",
  //     cardForeground: "#020817",
  //     popover: "#ffffff",
  //     popoverForeground: "#020817",
  //     primary: "#0284c7",
  //     primaryForeground: "#ffffff",
  //     secondary: "#f1f5f9",
  //     secondaryForeground: "#020817",
  //     muted: "#f1f5f9",
  //     mutedForeground: "#64748b",
  //     accent: "#f1f5f9",
  //     accentForeground: "#020817",
  //     destructive: "#ef4444",
  //     destructiveForeground: "#ffffff",
  //     border: "#e2e8f0",
  //     input: "#e2e8f0",
  //     ring: "#0284c7",
  //     radius: "0.5rem",
  //   },
  //   dark: {
  //     background: "#020817",
  //     foreground: "#f8fafc",
  //     card: "#020817",
  //     cardForeground: "#f8fafc",
  //     popover: "#020817",
  //     popoverForeground: "#f8fafc",
  //     primary: "#0ea5e9",
  //     primaryForeground: "#f8fafc",
  //     secondary: "#1e293b",
  //     secondaryForeground: "#f8fafc",
  //     muted: "#1e293b",
  //     mutedForeground: "#94a3b8",
  //     accent: "#1e293b",
  //     accentForeground: "#f8fafc",
  //     destructive: "#ef4444",
  //     destructiveForeground: "#f8fafc",
  //     border: "#1e293b",
  //     input: "#1e293b",
  //     ring: "#0ea5e9",
  //     radius: "0.5rem",
  //   },
  // },
  // search: {
  //   type: "pagefind",
  //   transformResults: ({ result, auth, context }) => {
  //     // Return false to filter out the result
  //     if (!auth.isAuthenticated) return false;
  //     // Return true or undefined to keep the original result
  //     if (result.url.includes("/")) return true;
  //     // Return a modified result
  //     return {
  //       ...result,
  //       title: `${result.excerpt} (${context.meta.title})`,
  //     };
  //   },
  // },
  // Right now this authentication is for Lift Tenant so we need to make sure to change clientId, issuer, and scopes for them.
  // authentication: {
  //   type: "openid",
  //   clientId: "6ljoqjrnsmskbd5g5o2ihf3jr3",
  //   issuer: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_C2KDVjPa0",
  //   scopes: ["openid", "aws.cognito.signin.user.admin"],
  // },

  // PREVIEW TENANT
  authentication: {
    type: "openid",
    clientId: "7lqh5sg239bs02h832j5mg9d26",
    issuer: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_ILMzyUE8D",
    scopes: ["openid", "aws.cognito.signin.user.admin"],
    redirectToAfterSignUp: "/changelog/platform",
    redirectToAfterSignIn: "/changelog/platform",
    redirectToAfterSignOut: "/changelog/platform",
  },
  protectedRoutes: {
    "/api/*": ({ auth }) => auth.isAuthenticated,
    "/docs/*": ({ auth }) => auth.isAuthenticated,
    // For advanced routes, check emailVerified on client-side only
    "/advanced/*": ({ auth }) => {
      console.log("[protectedRoutes /advanced/*] Checking auth:", auth);
      if (!auth.isAuthenticated) return false;

      // Only check emailVerified on client-side (not during SSR)
      if (
        typeof window !== "undefined" &&
        typeof localStorage !== "undefined"
      ) {
        try {
          const authString = localStorage.getItem("auth-state");
          if (authString) {
            const authData = JSON.parse(authString);
            const emailVerified = authData?.state?.profile?.emailVerified;
            console.log(
              "[protectedRoutes /advanced/*] emailVerified:",
              emailVerified,
            );

            if (emailVerified === "false") {
              console.log(
                "[protectedRoutes /advanced/*] Redirecting to /unauthorized",
              );
              setTimeout(() => {
                window.location.href = "/unauthorized";
              }, 0);
              return false;
            }
          }
        } catch (error) {
          console.error("[protectedRoutes /advanced/*] Error:", error);
        }
      }
      return true;
    },
    "/advanced-docs/*": ({ auth }) => {
      console.log("[protectedRoutes /advanced-docs/*] Checking auth:", auth);
      if (!auth.isAuthenticated) return false;

      // Only check emailVerified on client-side (not during SSR)
      if (
        typeof window !== "undefined" &&
        typeof localStorage !== "undefined"
      ) {
        try {
          const authString = localStorage.getItem("auth-state");
          if (authString) {
            const authData = JSON.parse(authString);
            const emailVerified = authData?.state?.profile?.emailVerified;
            console.log(
              "[protectedRoutes /advanced-docs/*] emailVerified:",
              emailVerified,
            );

            if (emailVerified === "false") {
              console.log(
                "[protectedRoutes /advanced-docs/*] Redirecting to /unauthorized",
              );
              setTimeout(() => {
                window.location.href = "/unauthorized";
              }, 0);
              return false;
            }
          }
        } catch (error) {
          console.error("[protectedRoutes /advanced-docs/*] Error:", error);
        }
      }
      return true;
    },
  },
  mdx: {
    components: {
      Tabs,
      AdvancedContent,
    },
  },
  site: {
    logo: {
      src: {
        light: "https://oloid.cloud/assets/images/website-logo.svg",
        dark: "https://oloid.cloud/assets/images/website-logo.svg",
      },
      alt: "Oloid",
      width: "130px",
    },
  },
  // metadata: {
  //   title: "Example Website Title",
  //   description: "This is an example description for the website.",
  //   logo: "https://example.com/logo.png",
  //   favicon: "https://example.com/favicon.ico",
  //   generator: "Website Generator 1.0",
  //   applicationName: "Example App",
  //   referrer: "no-referrer",
  //   keywords: ["example", "website", "metadata", "SEO"],
  //   authors: ["John Doe", "Jane Smith"],
  //   creator: "John Doe",
  //   publisher: "Example Publisher Inc.",
  // },
  navigation: [
    {
      type: "custom-page",
      path: "/",
      element: <Welcome />,
    },
    {
      type: "custom-page",
      path: "/changelog/upcoming/soon",
      element: <ComingSoon />,
    },
    {
      type: "custom-page",
      path: "/oauth/callback",
      element: <Welcome />,
    },
    {
      type: "custom-page",
      path: "/unauthorized",
      element: <Unauthorized />,
    },
    // {
    //   type: "link",
    //   label: "Login Cognito",
    //   to: "https://lift.auth.us-east-2.amazoncognito.com/login?client_id=6ljoqjrnsmskbd5g5o2ihf3jr3&response_type=code&scope=aws.cognito.signin.user.admin&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Foauth%2Fcallback",
    // },
    {
      type: "category",
      label: "Changelog",
      icon: "megaphone",
      items: [
        {
          type: "category",
          label: "Release notes",
          icon: "notebook-pen",
          collapsed: false,
          items: [
            {
              type: "category",
              label: "Web Portal",
              collapsed: false,
              items: [
                {
                  type: "link",
                  label: "Admin Portal",
                  to: "/changelog/platform",
                },
                {
                  type: "link",
                  label: "User Portal",
                  to: "/changelog/userportal",
                },
                // {
                //   type: "link",
                //   label: "Preview",
                //   to: "/changelog/upcoming/web",
                // },
                // {
                //   type: "link",
                //   label: "Coming Soon",
                //   to: "/changelog/upcoming/soon",
                // },
              ],
            },

            {
              type: "category",
              label: "Apps",
              collapsed: false,
              items: [
                {
                  type: "link",
                  label: "Android",
                  to: "/changelog/android",
                },
                {
                  type: "link",
                  label: "iOS",
                  to: "/changelog/ios",
                },
                {
                  type: "link",
                  label: "Windows",
                  to: "/changelog/windows",
                },
                {
                  type: "link",
                  label: "Webkey",
                  to: "/changelog/webkey",
                },
                {
                  type: "link",
                  label: "Oloid Vault",
                  to: "/changelog/oloidvault",
                },
                // {
                //   type: "link",
                //   label: "Preview",
                //   to: "/changelog/upcoming/apps",
                // },
                // {
                //   type: "link",
                //   label: "Coming Soon",
                //   to: "/changelog/upcoming/soon",
                // },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "category",
      label: "Scoped API Reference",
      icon: "code",
      items: [
        {
          type: "category",
          label: "Scoped APIs",
          icon: "sparkles",
          items: [
            "/scoped",
            {
              type: "link",
              icon: "key",
              label: "Login API",
              to: "/scoped/auth",
            },
            {
              type: "link",
              icon: "arrow-left-right",
              label: "Transaction API",
              to: "/scoped/transactions",
            },
            {
              type: "link",
              icon: "users",
              label: "Consent User API",
              to: "/scoped/consent",
            },
            {
              type: "link",
              icon: "square-library",
              label: "Activity Logs",
              to: "/scoped/rdsreport",
            },
          ],
        },
      ],
    },
    {
      type: "category",
      label: "API Reference",
      icon: "code",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/introduction",
            {
              type: "link",
              icon: "key",
              label: "Login API",
              to: "/api/auth",
            },
            {
              type: "link",
              icon: "square-library",
              label: "Reports API",
              to: "/api/reports",
            },
          ],
        },
        {
          type: "category",
          label: "Groups",
          icon: "users",
          items: [
            "/docs/groups",
            {
              type: "link",
              icon: "key",
              label: "Groups API",
              to: "/api/groups",
            },
          ],
        },
        {
          type: "category",
          label: "Users",
          icon: "user-round",
          items: [
            "/docs/users",
            {
              type: "link",
              icon: "key",
              label: "Users API",
              to: "/api/users",
            },
          ],
        },
        // {
        //   type: "category",
        //   label: "Useful Links",
        //   collapsible: false,
        //   icon: "link",
        //   items: [
        //     {
        //       type: "link",
        //       icon: "book",
        //       label: "Zudoku Docs",
        //       to: "https://zudoku.dev/docs/",
        //     },
        //   ],
        // },
      ],
    },
    {
      type: "category",
      label: "API Reference Advanced",
      icon: "user-lock",
      items: [
        "/example",
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/advanced-docs/introduction",
            {
              type: "link",
              icon: "key",
              label: "Login API",
              to: "/advanced/auth",
            },
          ],
        },
        {
          type: "category",
          label: "Applications",
          icon: "app-window",
          items: [
            "/advanced-docs/applications",
            {
              type: "link",
              icon: "key",
              label: "Application API",
              to: "/advanced/applications",
            },
          ],
        },
        {
          type: "category",
          label: "Connections",
          icon: "cable",
          items: [
            "/advanced-docs/connections",
            {
              type: "link",
              icon: "key",
              label: "Connection API",
              to: "/advanced/connections",
            },
          ],
        },
        {
          type: "category",
          label: "Credentials",
          icon: "rectangle-ellipsis",
          items: [
            "/advanced-docs/credentials",
            {
              type: "link",
              icon: "key",
              label: "Credentials API",
              to: "/advanced/credentials",
            },
          ],
        },
        {
          type: "category",
          label: "Endpoints",
          icon: "monitor-smartphone",
          items: [
            "/advanced-docs/endpoints",
            {
              type: "link",
              icon: "key",
              label: "Endpoints API",
              to: "/advanced/endpoints",
            },
          ],
        },
        {
          type: "category",
          label: "Settings",
          icon: "settings",
          items: [
            "/advanced-docs/settings",
            {
              type: "link",
              icon: "key",
              label: "Settings API",
              to: "/advanced/settings",
            },
          ],
        },
        {
          type: "category",
          label: "Tenant Settings",
          icon: "settings-2",
          items: [
            "/advanced-docs/tenantsettings",
            {
              type: "link",
              icon: "key",
              label: "Tenant Settings API",
              to: "/advanced/tenantsettings",
            },
          ],
        },
        {
          type: "category",
          label: "Transactions",
          icon: "arrow-left-right",
          items: [
            "/advanced-docs/transactions",
            {
              type: "link",
              icon: "key",
              label: "Transactions API",
              to: "/advanced/transactions",
            },
          ],
        },
        {
          type: "category",
          label: "User Consent",
          icon: "user-pen",
          items: [
            "/advanced-docs/consent",
            {
              type: "link",
              icon: "key",
              label: "User Consent API",
              to: "/advanced/consent",
            },
          ],
        },
        // {
        //   type: "category",
        //   label: "Useful Links",
        //   collapsible: false,
        //   icon: "link",
        //   items: [
        //     {
        //       type: "link",
        //       icon: "book",
        //       label: "Zudoku Docs",
        //       to: "https://zudoku.dev/docs/",
        //     },
        //   ],
        // },
      ],
    },
    // {
    //   type: "link",
    //   to: "/api",
    //   label: "API Reference",
    // },
  ],
  // plugins: [eventConsumerPlugin],
  redirects: [{ from: "/oauth/callback", to: "/changelog/platform" }],
  apis: [
    {
      type: "file",
      input: "./apis/rds-reports.yaml",
      path: "/api/reports",
    },
    {
      type: "file",
      input: "./apis/logins.yaml",
      path: "/api/auth",
    },
    {
      type: "file",
      input: "./apis/advancedlogins.yaml",
      path: "/advanced/auth",
    },
    {
      type: "file",
      input: "./apis/applications.yaml",
      path: "/advanced/applications",
      categories: [{ label: "General", tags: ["/applications"] }],
    },
    {
      type: "file",
      input: "./apis/connections.yaml",
      path: "/advanced/connections",
      categories: [{ label: "General", tags: ["/connections"] }],
    },
    {
      type: "file",
      input: "./apis/credentials.yaml",
      path: "/advanced/credentials",
      categories: [{ label: "General", tags: ["/credentials"] }],
    },
    {
      type: "file",
      input: "./apis/endpoints.yaml",
      path: "/advanced/endpoints",
      categories: [{ label: "General", tags: ["/endpoints"] }],
    },
    {
      type: "file",
      input: "./apis/groups.yaml",
      path: "/api/groups",
      categories: [{ label: "General", tags: ["/groups"] }],
    },
    {
      type: "file",
      input: "./apis/settings.yaml",
      path: "/advanced/settings",
      categories: [{ label: "General", tags: ["/settings"] }],
    },
    {
      type: "file",
      input: "./apis/tenantsettings.yaml",
      path: "/advanced/tenantsettings",
      categories: [{ label: "General", tags: ["/tenantsettings"] }],
    },
    {
      type: "file",
      input: "./apis/transactions.yaml",
      path: "/advanced/transactions",
      categories: [{ label: "General", tags: ["/transactions"] }],
    },
    {
      type: "file",
      input: "./apis/users.yaml",
      path: "/api/users",
      categories: [{ label: "General", tags: ["/users"] }],
    },
    {
      type: "file",
      input: "./apis/consent.yaml",
      path: "/advanced/consent",
      categories: [{ label: "General", tags: ["/consent"] }],
    },
    {
      type: "file",
      input: "./apis/scoped/logins.yaml",
      path: "/scoped/auth",
    },
    {
      type: "file",
      input: "./apis/scoped/transactions.yaml",
      path: "/scoped/transactions",
    },
    {
      type: "file",
      input: "./apis/scoped/consent.yaml",
      path: "/scoped/consent",
    },
    {
      type: "file",
      input: "./apis/scoped/rdsreport.yaml",
      path: "/scoped/rdsreport",
    },
  ],
};

export default config;

// import { eventConsumerPlugin, configureEmailPlugin } from "./zudoku-plugin";

// mdx file code for profile card view
// ---
// title: Oloid Platform
// owner: varun.mahurkar
// lastUpdated: 2025-08-08
// ---

// import ProfileCard from "./Profilecard.jsx";

// <ProfileCard title="Oloid Platform" owner="varun.mahurkar" />

// Configure email service
// configureEmailPlugin({
//   emailConfig: {
//     // For Gmail or other services
//     service: process.env.EMAIL_SERVICE || 'gmail',
//     auth: {
//       user: process.env.EMAIL_USER || 'your-email@gmail.com',
//       pass: process.env.EMAIL_PASS || 'your-app-password'
//     }
//     // For custom SMTP servers, use:
//     // host: process.env.SMTP_HOST || 'smtp.yourdomain.com',
//     // port: parseInt(process.env.SMTP_PORT || '587'),
//     // secure: process.env.SMTP_SECURE === 'true',
//     // auth: {
//     //   user: process.env.EMAIL_USER || 'noreply@yourdomain.com',
//     //   pass: process.env.EMAIL_PASS || 'your-password'
//     // }
//   },
//   defaultFrom: process.env.EMAIL_FROM || 'noreply@yourdomain.com',
//   notifications: {
//     onUserLogin: process.env.NOTIFY_USER_LOGIN === 'true',
//     onPageVisit: process.env.NOTIFY_PAGE_VISIT === 'true',
//     onError: process.env.NOTIFY_ERROR === 'true'
//   },
//   adminEmail: process.env.ADMIN_EMAIL || 'admin@yourdomain.com'
// });
